import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G2_P2_S1_Title: {
    id: `guide02.page02.slide01.title`,
  },
  G2_P2_S1_Description: {
    id: `guide02.page02.slide01.description`,
  },
  G2_P2_S1_A1_Title: {
    id: `guide02.page02.slide01.accordion1.title`,
  },
  G2_P2_S1_A1_Description: {
    id: `guide02.page02.slide01.accordion1.description`,
  },
  G2_P2_S1_A2_Title: {
    id: `guide02.page02.slide01.accordion2.title`,
  },
  G2_P2_S1_A2_Description: {
    id: `guide02.page02.slide01.accordion2.description`,
  },
  G2_P2_S1_A2_Button1_Label: {
    id: `guide02.page02.slide01.accordion2.button1.label`,
  },
  G2_P2_S1_A2_Button2_Label: {
    id: `guide02.page02.slide01.accordion2.button2.label`,
  },

  G2_P2_S1_A3_Title: {
    id: `guide02.page02.slide01.accordion3.title`,
  },
  G2_P2_S1_A3_Description: {
    id: `guide02.page02.slide01.accordion3.description`,
  },
  G2_P2_S1_A3_Button1_Label: {
    id: `guide02.page02.slide01.accordion3.button1.label`,
  },
  G2_P2_S1_A3_Button2_Label: {
    id: `guide02.page02.slide01.accordion3.button2.label`,
  },

  //Modals
  G2_P2_M_Loudspeakers_Title: {
    id: `guide02.page02.modal.loudspeakers.title`,
  },
  G2_P2_M_Loudspeakers_Description: {
    id: `guide02.page02.modal.loudspeakers.description`,
  },
  G2_P2_M_Loudspeakers_Caption: {
    id: `guide02.page02.modal.loudspeakers.caption`,
  },
  G2_P2_M_StudioRoom_Title: {
    id: `guide02.page02.modal.studioRoom.title`,
  },
  G2_P2_M_StudioRoom_Description: {
    id: `guide02.page02.modal.studioRoom.description`,
  },
  G2_P2_M_Headphones_Title1: {
    id: `guide02.page02.modal.headphones.title1`,
  },
  G2_P2_M_Headphones_Description1: {
    id: `guide02.page02.modal.headphones.description1`,
  },
  G2_P2_M_Headphones_Title2: {
    id: `guide02.page02.modal.headphones.title2`,
  },
  G2_P2_M_Headphones_Description2: {
    id: `guide02.page02.modal.headphones.description2`,
  },
  G2_P2_M_MonitoringController_Title: {
    id: `guide02.page02.modal.monitoringController.title`,
  },
  G2_P2_M_MonitoringController_Description: {
    id: `guide02.page02.modal.monitoringController.description`,
  },
  G2_P2_M_AudioInterface_Title: {
    id: `guide02.page02.modal.audioInterface.title`,
  },
  G2_P2_M_AudioInterface_Description: {
    id: `guide02.page02.modal.audioInterface.description`,
  },
  G2_P2_M_AudioInterface_Title2: {
    id: `guide02.page02.modal.audioInterface.title2`,
  },

  G2_P2_M_AudioInterface_P1_Title: {
    id: `guide02.page02.modal.audioInterface.p1.title`,
  },
  G2_P2_M_AudioInterface_P1_Description: {
    id: `guide02.page02.modal.audioInterface.p1.description`,
  },
  G2_P2_M_AudioInterface_P2_Title: {
    id: `guide02.page02.modal.audioInterface.p2.title`,
  },
  G2_P2_M_AudioInterface_P2_Description: {
    id: `guide02.page02.modal.audioInterface.p2.description`,
  },
  G2_P2_M_AudioInterface_P3_Title: {
    id: `guide02.page02.modal.audioInterface.p3.title`,
  },
  G2_P2_M_AudioInterface_P3_Description: {
    id: `guide02.page02.modal.audioInterface.p3.description`,
  },
  G2_P2_M_AudioInterface_P4_Title: {
    id: `guide02.page02.modal.audioInterface.p4.title`,
  },
  G2_P2_M_AudioInterface_P4_Description: {
    id: `guide02.page02.modal.audioInterface.p4.description`,
  },
  G2_P2_M_AudioInterface_P5_Title: {
    id: `guide02.page02.modal.audioInterface.p5.title`,
  },
  G2_P2_M_AudioInterface_P5_Description: {
    id: `guide02.page02.modal.audioInterface.p5.description`,
  },
  G2_P2_M_AudioInterface_P5_L1: {
    id: `guide02.page02.modal.audioInterface.p5.l1`,
  },
  G2_P2_M_AudioInterface_P5_L2: {
    id: `guide02.page02.modal.audioInterface.p5.l2`,
  },
  G2_P2_M_AudioInterface_P5_L3: {
    id: `guide02.page02.modal.audioInterface.p5.l3`,
  },
  G2_P2_M_Acoustics_Title: {
    id: `guide02.page02.modal.acoustics.title`,
  },
  G2_P2_M_Acoustics_Description: {
    id: `guide02.page02.modal.acoustics.description`,
  },
  G2_P2_M_Microphones_Title: {
    id: `guide02.page02.modal.microphones.title`,
  },
  G2_P2_M_Microphones_Description: {
    id: `guide02.page02.modal.microphones.description`,
  },
  G2_P2_M_Daw_Title: {
    id: `guide02.page02.modal.daw.title`,
  },
  G2_P2_M_Daw_Description1: {
    id: `guide02.page02.modal.daw.description1`,
  },
  G2_P2_M_Daw_Description2: {
    id: `guide02.page02.modal.daw.descriptio2`,
  },
  G2_P2_M_Virtualisation_Title: {
    id: `guide02.page02.modal.virtualisation.title`,
  },
  G2_P2_M_Virtualisation_Description1: {
    id: `guide02.page02.modal.virtualisation.description1`,
  },
  G2_P2_M_Virtualisation_Description2: {
    id: `guide02.page02.modal.virtualisation.description2`,
  },
});
